import { render, staticRenderFns } from "./GroupOrderDetails.vue?vue&type=template&id=41f62f86&scoped=true"
import script from "./GroupOrderDetails.vue?vue&type=script&lang=js"
export * from "./GroupOrderDetails.vue?vue&type=script&lang=js"
import style0 from "./GroupOrderDetails.vue?vue&type=style&index=0&id=41f62f86&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41f62f86",
  null
  
)

export default component.exports